import { useCallback } from "react";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import type { IntegrationAccount } from "app/pages/sales-intelligence/modules/company-analysis/types/crm-links";
import withDelayedHoverEvent from "app/pages/sales-intelligence/hoc/withDelayedHoverEvent";
import withMouseEventHandlers from "app/pages/sales-intelligence/hoc/withMouseEventHandlers";

import MultipleAccountsTag from "./MultipleAccountsTag";

type MultipleAccountsTagTrackedProps = {
    accounts: readonly IntegrationAccount[];
    preferredAccount: Readonly<IntegrationAccount> | undefined;
};

const AccountTagWithMouseEvents = withDelayedHoverEvent(withMouseEventHandlers(MultipleAccountsTag));

const MultipleAccountsTagTracked = ({ accounts, preferredAccount }: MultipleAccountsTagTrackedProps) => {
    const handleAccountClick = useCallback((account: IntegrationAccount) => {
        companyAnalysisTrackingService.overview.trackOpenCRMAccountFromMultiple(account.crmAccountId);
    }, []);

    const handleOnMouseEnter = (): void => {
        companyAnalysisTrackingService.overview.trackHoverCRMAccountFromMultiple(
            preferredAccount?.crmAccountId ?? "Unknown",
        );
    };

    return (
        <AccountTagWithMouseEvents
            accounts={accounts}
            onMouseEnter={handleOnMouseEnter}
            onAccountClick={handleAccountClick}
        />
    );
};

export default MultipleAccountsTagTracked;
